<template>
  <div>

    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/horario"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.nometurno }} - {{ propSlot.item.horarioinicio }} às {{ propSlot.item.horariotermino }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novoHorario"
      :editar="editarHorario"
      :excluir="excluirHorario"
      :cancelar="cancelarHorario"
      :id="form.identificadorhorario"
      class="mb-3">

      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaHorario">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>

      <v-card class="pa-3">
        <Input type="text" label="Código do Horário" disabled v-model="form.identificadorhorario" />
        <Select :options="nomeTurnoOptions" v-model="form.nometurno" label="Turno*" :disabled="acao == ''" :v="$v.form.nometurno"/>
        <Input type="time" :disabled="acao == 'editar' || acao == ''" v-model="form.horarioinicio" label="Horário de Início*"/>
        <Input type="time" :disabled="acao == 'editar' || acao == ''" v-model="form.horariotermino" label="Horário de Término*"/>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

  </div>
</template>

<script>
import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { required, maxLength, alpha } from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadorhorario: '',
  nometurno: '',
  horarioinicio: '',
  horariotermino: ''
});

export default {
  name: 'horario',
  components: { BuscaSimplesApi },

  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'nometurno',
      buscaOptions: [
        { value: 'identificadorhorario', text: 'Código do Horário' },
        { value: 'nometurno', text: 'Turno' },
        { value: 'horarioinicio', text: 'Horário de Início' },
        { value: 'horariotermino', text: 'Horário de Término' },
      ],
      nomeTurnoOptions: [
        { value: '' , text: '' },
        { value: 'Matutino' , text: 'Matutino' },
        { value: 'Vespertino' , text: 'Verpertino' },
        { value: 'Noturno' , text: 'Noturno' },
        { value: 'Integral' , text: 'Integral' }
      ]
    };
  },

  validations() {
    return {
      form: {
        nometurno: { required, maxLength: maxLength(10), alphaSpace },
        horarioinicio: { required },
        horariotermino: { required }
      }
    };
  },

  methods: {
    tabelaHorario(){
      this.$root.$router.push({
          name: 'tabelas',
          params: {
            titulo: 'Horário / Listar',
            rota_api: 'gerencial/horario/tabela',
            headers: [{ text: 'Identificador', value: 'identificadorhorario', filtable: true, sortable: false},
                      { text: 'Turno', value: 'nometurno', filtable: true, sortable: false},
                      { text: 'Horário de Início', value: 'horarioinicio', filtable: true, sortable: false},
                      { text: 'Horário de Término', value: 'horariotermino', filtable: true, sortable: false}]
          }
      });
    },

    novoHorario() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.form = {
        ...this.form,
      };
      this.$v.$reset();
    },

    editarHorario() {
      if (this.form.identificadorhorario !== '') {
        this.acao = 'editar';
      }
    },

    async excluirHorario() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este horário?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/horario/${this.form.identificadorhorario}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage,
            type: 'notification',
          });
        }
      }
    },

    cancelarHorario() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        const response = await api({
          method: (this.acao === 'novo') ? 'post' : 'put',
          url: `gerencial/horario${(this.acao === 'novo') ? '' : `/${this.form.identificadorhorario}`}`,
          data: this.form,
        });

        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        if (this.acao == '') { this.form = { ...response.data.results }; }
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
      return true;
    },

    encontrado(dados) {
      this.form = setFormInicial();
      this.form = {
        ...dados,
      };
      this.formUltimo = { ...this.form };
      this.$refs.buscaSimpleApi.lista = [];
    },

    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    }
  },
};
</script>

<style lang="scss">
</style>
